// eslint-disable-next-line import/prefer-default-export
export enum OrderStatus {
  TO_DELIVERED = "to_delivered",
  DELIVERED_OK = "delivered_ok",
  DELIVERED_INCOMPLETE = "delivered_incomplete",
  CANCELED = "canceled",
}

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  [OrderStatus.TO_DELIVERED]: "En cours",
  [OrderStatus.DELIVERED_OK]: "Livré total",
  [OrderStatus.DELIVERED_INCOMPLETE]: "Livré partiel",
  [OrderStatus.CANCELED]: "Annulée",
};
